import CityPageTemplate from "../city-template/CityPageTemplate";
import { oxnardConfig } from "./data";

export default function OxnardPage() {
  return <CityPageTemplate config={oxnardConfig} />;
}